import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const TagUser = React.lazy(() =>
    import('../TagUser')
);
const tagUserRoutesRegistry = [
    {
        path: PAGE_URL.TAG_USER_PAGE,
        element: <TagUser />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tagUserRoutesRegistry;
